import gql from 'graphql-tag'

export const GET_FORUM_CATEGORIES = gql`
  query categoriasForum($curso_id: String!) {
    categoriasForum(curso_id: $curso_id) {
      _id
      titulo
      trilhas {
        titulo
        items {
          _id
          titulo
        }
      }
      
    }
  }
`

export const GET_FORUM_TOPICS = gql`
  query topicosForum($curso_id: String, $page: Int, $categoria_id: String, $sort: String) {
    topicosForum(curso_id: $curso_id, page: $page, categoria_id: $categoria_id, sort: $sort) {
      edges {
        _id
        titulo
        descricao
        createdAt
        visualizacoes
        postadoPor
        quantidadeRespostas
        categoria {
          label
        }
      }
      total
      pagesAmount
      page
    }
  }
`

export const GET_FORUM_TOPIC = gql`
  fragment Respostas on RespostaRespostaForum {
    _id
    descricao
    createdAt
    postadoPor
  }
  query topicoForum($topico_id: String!) {
    topicoForum(topico_id: $topico_id) {
      _id
      titulo
      descricao
      createdAt
      visualizacoes
      postadoPor
      categoria {
        label
      }
      respostas {
        _id
        descricao
        createdAt
        postadoPor
        respostas {
          ...Respostas
          respostas {
            ...Respostas
            respostas {
              ...Respostas
            }
          }
        }
      }
    }
  }
`
